var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"animation16interface"}},[_c('lottie',{attrs:{"options":_vm.defaultOptions,"autoplay":true,"speed":0.05,"loop":false,"height":450,"width":450},on:{"animCreated":_vm.handleAnimation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }